import React from 'react'
import { render } from 'react-dom'
import { Provider } from 'react-redux'
import { createStore, applyMiddleware } from 'redux'
import { composeWithDevTools } from 'redux-devtools-extension'
import Thunk from 'redux-thunk'
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider'
import getMuiTheme from 'material-ui/styles/getMuiTheme'
import App from './app'
// import registerServiceWorker from './registerServiceWorker'
import Reducers from './reducers/'

import 'react-dates/initialize'
import 'react-dates/lib/css/_datepicker.css'
import './style/index.scss'

const store = createStore(Reducers, composeWithDevTools(applyMiddleware(Thunk)))

const myTheme = getMuiTheme({
  fontFamily: 'TruenoLt, sans-serif',
  palette: {
    primary1Color: '#00AD4C',
    primary2Color: '#005870',
    primary3Color: '#F7911E',
    accent1Color: '#3DB659',
    // accent2Color: grey100,
    // accent3Color: grey500,
    textColor: '#000000',
    // alternateTextColor: white,
    // canvasColor: white,
    // borderColor: grey300,
    // disabledColor: fade(darkBlack, 0.3),
    // pickerHeaderColor: cyan500,
    // clockCircleColor: fade(darkBlack, 0.07),
    // shadowColor: fullBlack,
  },
})

render(
  <Provider store={store}>
    <MuiThemeProvider muiTheme={myTheme}>
      <App />
    </MuiThemeProvider>
  </Provider>,
  document.getElementById('root')
)
